// The sentence under "If the lead does not answer" in the Speed to Lead step. PURE, so the wording is asserted without a render.
//
// ⚠️ AI SMS is only mentioned when it is ON (Phase 2, Part A): a club with calls on and AI SMS off must not be told that a text
// will follow, because none will. Without AI SMS the call simply ends.

export function noAnswerSentence(aiSmsOn: boolean): string {
  return aiSmsOn
    ? 'If the lead does not answer (no answer, busy, rejected or failed), the call ends, the retry above applies if set, and AI SMS texts straight away.'
    : 'If the lead does not answer (no answer, busy, rejected or failed), the call simply ends, and the retry above applies if set.';
}
